// Sundanese translations
export const su: Record<string, string> = {
  'menu.dashboard': 'Dashboard',
  'menu.customers': 'Palanggan',
  'menu.products': 'Produk',
  'menu.users': 'Pamaké',
  'menu.settings': 'Setélan',
  'menu.logout': 'Kaluar',
  'dashboard.title': 'Dashboard',
  'dashboard.newOrder': 'Pesenan Anyar',
  'order.title': 'Pesenan Anyar',
  'order.customer': 'Palanggan',
  'order.products': 'Produk',
  'order.total': 'Total',
  'users.title': 'Pamaké',
  'users.name': 'Ngaran',
  'users.email': 'Émail',
  'common.yes': 'Enya',
  'common.no': 'Henteu',
  'common.cancel': 'Bolay',
  'common.save': 'Simpen',
  'common.search': 'Paluruh',
  'common.perPage': 'Per Page',
  'common.page': 'Page',
  'common.orders': 'Orders',
  'common.previous': 'Previous',
  'common.next': 'Next',
  'common.pieces': 'pieces',
  'login.title': 'Cleandy',
  'login.login': 'Lebet',
  'login.welcome': 'Wilujeng sumping, {name}',
  'login.tagline': 'Dry cleaning software — Smart and easy solutions for your business.',
  'signup.email': 'Émail',
  'signup.phone': 'Telepon',
  'menu.reportsAndAccounting': 'Laporan & Akuntansi',
  'menu.systemAndCommunication': 'Sistem & Komunikasi',
};